import React, { useState } from "react";
import { Dropdown, FormControl } from "react-bootstrap";
import "../../styles/commoncomponents/dropDownSearch.scss";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button
    href=""
    className="dropDownSearch"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
    <i className="fa fa-th" />
  </button>
));

const CustomMenu = React.forwardRef(
  ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
    const [value, setValue] = useState("");

    return (
      <div
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
      >
        <FormControl
          autoFocus
          className="mx-3 my-2 w-auto"
          placeholder="Type to filter..."
          onChange={(e) => setValue(e.target.value)}
          value={value}
        />
        <ul className="list-unstyled">
          {React.Children.toArray(children).filter(
            (child) =>
              !value || child.props.children.toLowerCase().includes(value)
          )}
        </ul>
      </div>
    );
  }
);

function DropDownSearch(props) {
  return (
    <Dropdown>
      <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
        {props.caption}
      </Dropdown.Toggle>

      <Dropdown.Menu as={CustomMenu}>
        {props.values.length == 0 ?
          <Dropdown.Item>
            No items
          </Dropdown.Item>
          : props.values.map((value) => {
            return (
				<Dropdown.Item
					key={value.groupId}
					eventKey="1"
					onClick={() => props.onParentCall(value)}
				>
					{props.fromPOI == "true"
						? value.name
						: `${value.customername} - ${value.groupName} `}
				</Dropdown.Item>
			);
          })}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default DropDownSearch;
